module.exports = __webpack_public_path__ + "img/input-text-icon.9f7b3753.svg";